module.exports = __webpack_public_path__ + "static/media/002-battery charge.298604c2.svg";